import { useMainNavItems } from 'shared/hooks/useMainNavItems'
import { useFooterNavItems } from 'shared/hooks/useFooterNavItems'
import { useIsMobileSm } from 'shared/hooks/useBreakpoint'

export const useBottomBar = () => {
	const isMobileSm = useIsMobileSm()
	const mainNavItems = useMainNavItems({
		applicationsLabel: isMobileSm ? 'Apps' : 'Applications',
	})
	const footerNavItems = useFooterNavItems()

	return { navItems: [...mainNavItems, ...footerNavItems] }
}
